<mat-spinner *ngIf="spinner" class="center"></mat-spinner>

<section>


  <!-- CLOSE BUTTON -->
  <button type="button" class="close-button m-2 mb-0"
      mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <!-- <h4 mat-dialog-title>Študijné programy</h4> -->
  <h3 mat-dialog-title>{{getNazovDialogu()}}</h3>

  <mat-dialog-content class="mat-typography m-auto">
    <div class="mb-2">
      <form (ngSubmit)="onSubmit()" #myForm="ngForm">

        <div class="form-group">
          <!-- <p><mat-icon>help</mat-icon></p> -->
          <div class="d-flex justify-content-end">
            <button
              mat-icon-button
              type="button"
              (click)="zobrazitHelpText = !zobrazitHelpText"
              aria-label="Help button - otaznik"
              matTooltip="{{getHelpTooltipText()}}">
              <mat-icon class="help-icon">help</mat-icon>
            </button>
          </div>
          <div *ngIf="zobrazitHelpText"
               style="font-size: 75%; color: rgb(50,50,50);text-align: justify;
                margin: 0px 10px 5px 10px;">
            {{getHelpTooltipText()}}
          </div>
          <mat-form-field appearance="outline" class="full-width
              filtrovaci-input">
            <button
              mat-icon-button
              class="mx-2"
              type="button"
              (click)="vyhladajPodprogramy(searchedDataInput)"
              enter
              [disabled]="myForm.invalid"
              [matTooltip]="getHladajTooltip()"
              matPrefix>
              <mat-icon>search</mat-icon>
            </button>
            <mat-label i18n>Hľadaj</mat-label>
            <input
              matInput
              type="text"
              minlength="2"
              id="searchedDataInput"
              [(ngModel)]="searchedDataInput"
              name="searchedDataInput"
              required
              placeholder="{{getSearchedDataInputPlaceholder()}}"
              (keydown.enter)="vyhladajPodprogramy(searchedDataInput, myForm.invalid)"
              cdkFocusInitial
              >
            <button
              *ngIf="searchedDataInput"
              class="me-2"
              mat-icon-button
              [disabled]="myForm.invalid"
              (click) = "clearSearchInput($event)"
              (keydown)="keyPressed()"
              matTooltip="{{getZmazText()}}"
              matSuffix
              >
              <mat-icon>clear</mat-icon>
            </button>
            <!-- <mat-icon>sentiment_very_satisfied</mat-icon> -->
            <mat-hint i18n>*min. 2 znaky</mat-hint>
          </mat-form-field>
        </div>

      </form>
    </div>

    <div *ngIf="podprogramyDotiahnute === false"
        class="text-danger text-center" i18n>
      Nenašli sa žiadne výsledky vyhľadávania.
    </div>


    <div>
      <mat-radio-group
        [(ngModel)]="indexOznacenyPodprogram"
        class="d-flex flex-column"
        aria-label="Select an option"
        (change)="onPodprogramRadioBoxChange()">
        <mat-radio-button
          [ngClass]="{'spodny-okraj-radiobox': i - indexOznacenyPodprogram === 0
            && jazykyZvolenehoPodprogramu.length > 0,
            'spodny-okraj-radiobox-2': i - indexOznacenyPodprogram === 0
              && jazykyZvolenehoPodprogramu.length === 0}"
          value="{{i}}"
          *ngFor="let podprogram of podprogramyZRegistraPole; index as i">
          <!-- <div [ngClass]="{'haha': i - indexOznacenyStudProgram === 0}"> -->
          <div>
            {{podprogram.skratka}} - {{podprogram.popis}}
          </div>
          <div class="p-2" *ngIf="oznaceniePodprogramovPole[i]">
            <section *ngIf="jazykyZvolenehoPodprogramu.length > 0;else upozornenieTemplate">
              <mat-checkbox [(ngModel)]="jazyk.oznaceny" (change)="overitDisablovaniePotvrditButtonu()"
                  *ngFor="let jazyk of jazykyZvolenehoPodprogramu" [checked]="true">

                {{jazyk.kod}}
              </mat-checkbox>
            </section>
            <ng-template #upozornenieTemplate>
              <div class="text-danger">
                {{upozornenieText}}
              </div>
            </ng-template>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    <!-- <mat-checkbox [(ngModel)]="akcia.prihlaseny" [disabled]="false" (click)="checkboxClick($event)"></mat-checkbox> -->
      <!-- <app-studijny-program [studProgram]="studProgram"></app-studijny-program> -->


    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close i18n>Zrušiť</button>
    <button mat-stroked-button [mat-dialog-close]="dataMatDialog.pocetSkopirovanychPoloziek"
      [disabled]="disablovanyPotvrditButton"
      (click)="potvrditVyberPodprogramu()" i18n>Potvrdiť</button>
  </mat-dialog-actions>

</section>
